import React, { useState } from 'react';
import { Button } from 'antd';
import { Col, Row } from 'reactstrap';
import Users from './components/Users';
import { URL } from '../../config/api';

const ExamplePage = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [update, setUpdate] = useState(0);
  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');

  const openAddModal = () => {
    setUpdate(update + 1);
    setModalVisible(true);
  }

  const downloadBackup = async () => {
    window.open(`${URL}/backup/backup.php?UserId=${id}&Token=${token}`, "_blank");
  }

  return (
    <div className="dashboard-container">
      <Row>
        <Col md={12}>
          <div style={{justifyContent: 'space-between', display: 'flex'}}>
            <h3 className="page-title">Users</h3>
            {localStorage.getItem('type') == 0 &&
            <Button type="text" onClick={() => downloadBackup()}>Download Database Backup</Button>}
            <Button type="text" onClick={() => openAddModal()}>Add User</Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Users setModalVisible={(value) => setModalVisible(value)} modalVisible={modalVisible} setUpdate={(value) => setUpdate(value)} update={update} />
      </Row>
    </div>
  )
};

export default ExamplePage;
